const doRounding = (num: number) => {
  return Math.sign(num) * Math.round(Math.sign(num) * num);
};

export function fixRounding(value: number, precision: number) {
  const power = Math.pow(10, precision || 0);
  return doRounding(value * power) / power;
}
